// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Util
import {
    getElementTemplateLink,
    getElementTemplateExampleLink,
    getTemplateStatusText,
} from '../../../../../common/templates/templateUtil';

// Actions
import { navigateToBoard } from '../../../../reducers/navigationActions';

// Component
import Button from '../../../../components/buttons/Button';

import './TemplateStatusUtil.scss';

const mapDispatchToProps = (dispatch) => ({
    dispatchNavigateToBoard: (boardId) => dispatch(navigateToBoard({ boardId })),
});

const TemplateStatusUtil = ({ currentBoard, dispatchNavigateToBoard }) => {
    const emptyStateLink = getElementTemplateLink(currentBoard);
    const exampleStateLink = getElementTemplateExampleLink(currentBoard);

    if (emptyStateLink) {
        return (
            <div className="TemplateStatusUtil">
                <Button onClickFn={() => dispatchNavigateToBoard(emptyStateLink)}>
                    {getTemplateStatusText(currentBoard)}
                </Button>
            </div>
        );
    }

    if (exampleStateLink) {
        return (
            <div className="TemplateStatusUtil">
                <Button onClickFn={() => dispatchNavigateToBoard(exampleStateLink)}>
                    {getTemplateStatusText(currentBoard)}
                </Button>
            </div>
        );
    }

    return <div className="TemplateStatusUtil">{getTemplateStatusText(currentBoard)}</div>;
};

TemplateStatusUtil.propTypes = {
    currentBoard: PropTypes.object,
    dispatchNavigateToBoard: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(TemplateStatusUtil);
